import { useLogin } from '@shared/hooks/useLogin';

import { DialogButton } from '@ui/uikit/components/common/Dialog';

export const ConnectWalletButton = () => {
  const { login, isLogging } = useLogin();

  const onClickConnect = () => {
    void login({
      signMessage: 'Confirm authorization in Magic Store with your wallet',
    });
  };

  return (
    <div className="max-w-full">
      <DialogButton isDisabled={isLogging} onClick={onClickConnect} type="button">
        Connect Wallet
      </DialogButton>
    </div>
  );
};
